<!--说明书管理-->
<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="3">
                <el-input :size="size" placeholder="请输入名称" v-model="queryInfo.name" clearable></el-input>
            </el-col>
            <el-col :span="4">
                <el-button :size="size" v-permission="['BUSINESS-MANUAL-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            </el-col>
            <el-col :span="17" style="text-align: right;">
                <el-button :size="size" v-permission="['BUSINESS-MANUAL-ADD']" type="primary" icon="el-icon-upload" @click="addManual">上传说明书</el-button>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
            <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" >
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.prop==='status'">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="!scope.row.status" >无效</el-tag>
                            <el-tag type="success" v-if="scope.row.status" >有效</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.label==='操作'">
                        <template slot-scope="scope"><!-- -->
                            <el-button v-permission="['BUSINESS-MANUAL-UPDATE']" type="primary" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">编辑</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-view" round @click="showDialog(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <div v-if="editDialogVisible">
            <el-dialog :title="title"
                       :visible.sync="editDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="50%"
                       @close="handleCloseEdit">
                <el-form :model="editItem" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <el-col :span="12" >
                        <el-form-item label="名称：" prop="name">
                            <el-input clearable v-model="editItem.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="版本号：" prop="manualVersion">
                            <el-input clearable v-model="editItem.manualVersion"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="备注：" prop="remark">
                            <el-input clearable v-model="editItem.remark"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="editShow" >
                        <el-form-item label="是否删除：" prop="delFlag">
                            <el-select clearable v-model="editItem.delFlag" style="width: 100%;">
                                <el-option
                                        v-for="item in delFlagList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="editShow" >
                        <el-form-item label="状态：" prop="status">
                            <el-select clearable v-model="editItem.status" style="width: 100%;">
                                <el-option
                                        v-for="item in statusList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="title==='上传说明书'">
                        <el-form-item label="上传说明书：" prop="">
                            <!--:limit="1"+
                            -->
                            <el-upload
                                    class="avatar-uploader"
                                    :class="{hide:hideUploadIcon}"
                                    ref="upload"
                                    :action="''"
                                    :multiple="false"

                                    :on-change="onchange"
                                    :show-file-list="false"
                                    :auto-upload="false">
                                <i class="el-icon-plus"></i>
                                <span v-if="filename!=null&&filename!=''">{{filename}}</span>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="editFun">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="drawer">
            <el-dialog
                    title="请用手机扫码查看"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :destroy-on-close="true"
                    width="30%"
                    :visible.sync="drawer">
            <div style="text-align: center;">
                <img :src="QRImgUrl">
            </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import QRCode from 'qrcode'
    import {manualPage,manualEdit,manualAdd} from '@/api/manual'
    import Pagination from '@/components/pagination'
    export default {
        name: 'BUSINESS-MANUAL',
        components: {
            Pagination
        },
        data(){
            return {
                tablelist: [],
                columns: [
                    {
                        label: '名称',
                        prop: 'name',
                        //width: '280px',
                        fixed: 'left'
                    },{
                        label: '版本号',
                        prop: 'manualVersion',
                        //width: '180px'
                    },{
                        label: '备注',
                        prop: 'remark',
                        //width: '100px'
                    },{
                        label: '状态',
                        prop: 'status',
                        width: '100px'
                    },{
                        label: '操作',
                        type: 'template',
                        prop: 'action',
                        width: '180px',
                        fixed: 'right'
                    }
                ],
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1
                },
                total: 0,
                editItem:{
                    remark:''
                },
                editDialogVisible:false,
                editFormRules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    manualVersion:[
                        { required: true, message: '请输入版本号', trigger: 'blur' }
                    ],
                    delFlag:[
                        { required: true, message: '请选择是否删除', trigger: 'blur' }
                    ],
                    status:[
                        { required: true, message: '请选择是否有效', trigger: 'blur' }
                    ]
                },
                statusList:[
                    {value:true,label:'有效'},
                    {value:false,label:'无效'}
                ],
                delFlagList:[
                    {value:true,label:'删除'},
                    {value:false,label:'保留'}
                ],
                size:this.COMMON.size,
                hideUploadIcon:true,
                title:'添加说明书',
                filename:null,
                treeTableHeight:650,
                editShow:false,
                loading: true,
                drawer:false,
                QRImgUrl:''
            }
        },
        methods:{
            getHeight() {
                if(this.total>0){
                    this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 -33 + 'px'
                }else{
                    this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 + 'px'
                }
            },
            init(){
                if(this.queryInfo.name!=undefined) {
                    this.queryInfo.name = this.queryInfo.name.trim()
                }
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.loading = true
                manualPage(param,this.queryInfo).then(response => {
                    // console.log('用户列表',response.data)
                    if(response.code!=200){
                        return this.$message.error(response.msg)
                    }
                    this.tablelist = response.data.records
                    this.total = response.data.total
                    this.getHeight()
                    this.loading = false
                })
            },
            /**
             * 分页组件切换分页大小事件处理
             * @param newSize
             */
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.init()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.init()
            },
            showEditDialog(item){
                this.editItem=JSON.parse(JSON.stringify(item))
                this.editShow=true
                this.editDialogVisible=true
                this.title='编辑说明书'
            },
            handleCloseEdit(){
                // this.$refs.editFormRef.resetFields()
                this.editItem = {
                    remark:'',
                    name:'',
                    file:''
                }
                this.filename = ''
                this.editDialogVisible=false
            },
            handleCloseUP(){
                this.upDialogVisible=false
            },
            editFun(){
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) return
                    if(this.title==='上传说明书'){
                        this.param = new FormData()
                        this.param.append('file',this.editItem.file)
                        this.param.append('delFlag',this.editItem.delFlag)
                        this.param.append('manualVersion',this.editItem.manualVersion)
                        this.param.append('name', this.editItem.name)
                        this.param.append('remark', this.editItem.remark)
                        this.param.append('status', this.editItem.status)
                        manualAdd(this.param).then(response => {
                            console.log(response)
                            if (response.code != 200)
                                return this.$message.error(response.msg)
                            this.$message.success(response.msg)
                            this.handleCloseEdit()
                            this.init()
                        })
                    }else{
                        manualEdit(this.editItem).then(response => {
                            if(response.code!=200){
                                return this.$message.error(response.msg)
                            }
                            this.$message.success(response.msg)
                            this.init()
                            this.handleCloseEdit()
                        })
                    }
                })
            },
            addManual(){
                this.editDialogVisible=true
                this.title='上传说明书'
                this.editShow=false
                this.editItem.status=true
                this.editItem.delFlag=false
            },
            onchange(file,fileList){
                console.log(file,fileList)
                const isPDF = file.raw.type === 'application/pdf'
                if(!isPDF){
                    this.$message.error('上传文件只能是 PDF 格式!')
                    return false
                }else{
                    this.editItem.file = file.raw
                    this.filename=file.name
                }
            },
            showDialog(item){
                let url=this.COMMON.httpUrl+'/static'+item.path + '?token=Bearer '+ this.token
                QRCode.toDataURL(
                    url,
                    {errorCorrectionLevel:'L',margin:2,width:128},
                    (err,url)=>{
                        if(err) throw err
                        this.QRImgUrl = url
                    }
                )
                this.drawer=true
                //window.open(url,'_blank')
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.init()
            }
        },
        computed:{
            ...mapGetters([
                'token'
            ]),
        },
        created() {
            this.init()
            window.addEventListener('resize', this.getHeight)
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>

</style>
